import { render, staticRenderFns } from "./Schedules-User.vue?vue&type=template&id=4671c8a5"
import script from "./Schedules-User.js?vue&type=script&lang=js&external"
export * from "./Schedules-User.js?vue&type=script&lang=js&external"
import style0 from "./Schedules-User.vue?vue&type=style&index=0&id=4671c8a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports